import React from 'react';
import {useStyles} from "../ArticleWarehouses.style";
import clsx from "clsx";
import ArticleWarehouseRowProperties from "./ArticleWarehouseRowProperties";
import ShowSellerBasicInfo from "../../../shared_components/Info/ShowSellerBasicInfo/ShowSellerBasicInfo";

const ArticleWarehouseRowSmall: React.FC<ArticleWarehouseRowProperties> = ({articleWarehouse, onUpdate}) => {

    const classes = useStyles();

    return (
        <div className={clsx(classes.article_warehouse_info_container_small)}>
            <ShowSellerBasicInfo autofill name={articleWarehouse.name}/>
            <div className={classes.menu_container_small}>
                <></>
            </div>
        </div>
    )
}

export default ArticleWarehouseRowSmall;
